<template>
  <div class="py-8">
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-light-blue">{{ icons.arrowLeft }}</v-icon>
        <router-link
          class="text-decoration--none"
          :to="{ name: 'privacy-policy' }"
          >Privacy Policy</router-link
        >
      </v-toolbar-title>
    </v-app-bar>

    <div class="ma-4">
      <div class="display-2 font-weight-light mb-10 font-serif text-capitalize">
        Privacy Policy
      </div>
      <privacy-policy-form v-if="!loading" :privacy-policy="privacyPolicy" />
    </div>

    <v-overlay absolute :value="loading" opacity="0.2">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import {
  mdiChevronLeft,
  mdiCheck,
  mdiAlertCircleOutline,
  mdiAccountOff
} from '@mdi/js'
import { mapState, mapActions, mapMutations } from 'vuex'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import PrivacyPolicyForm from '@/views/Home/PrivacyPolicy/components/PrivacyPolicyForm'

export default {
  name: 'TermDetails',

  components: {
    PrivacyPolicyForm,
    AppBarNavIcon
  },

  data() {
    return {
      icons: {
        arrowLeft: mdiChevronLeft,
        check: mdiCheck,
        alert: mdiAlertCircleOutline,
        block: mdiAccountOff
      },
      loading: false
    }
  },

  computed: {
    ...mapState({
      privacyPolicy: state => state.support.privacyPolicyDetails
    })
  },

  watch: {
    $route() {
      this.getPrivacyPolicy()
    }
  },

  methods: {
    ...mapActions({
      logout: 'auth/logout',
      getPrivacyPolicyDetails: 'support/getPrivacyPolicyDetails'
    }),

    ...mapMutations({
      clearPrivacyPolicyDetails: 'support/clearPrivacyPolicyDetails'
    }),

    async getPrivacyPolicy() {
      this.loading = true
      await this.getPrivacyPolicyDetails()
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          if (error.response && error.response.status === 403) {
            this.logout()
          }
        })
    }
  },

  created() {
    this.getPrivacyPolicy()
  },

  destroyed() {
    this.clearPrivacyPolicyDetails()
  }
}
</script>
